export default __webpack_public_path__ + "static/media/Dead (6).15cfabf1.png";